import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OidcService {
  private _http: HttpClient;

  constructor(handler: HttpBackend) {
    this._http = new HttpClient(handler);
  }

  /**
   * Identity Discovery - obscured endpoint name
   */
  checkContext(email: string) {
    const url = `${environment.pureSpectrum.authUrl}/oidc/interaction/check-context`;
    return this._http.get<{
      valid: boolean;
      ts: number;
      config?: {
        clientId: string;
        redirectUri: string;
        scope: string;
        responseType: string;
        redirectTimeout: number;
        upstreamId?: string;
      };
    }>(url, {
      params: new HttpParams().set('id', email),
    });
  }

  /**
   * Token Exchange
   */
  exchangeCode(payload: any) {
    const url = `${environment.pureSpectrum.authUrl}/oidc/interaction/exchange`;
    return this._http.post<any>(url, payload);
  }
}
